import { useCustomHistory } from "hooks";
import { useParams, useHistory } from "react-router-dom";
import useQueryParam from "./useQueryParam";
import { useSelector } from "react-redux";

const useDineIn = () => {
    const params = useParams();
    const router = useCustomHistory();
    const queryParam = useQueryParam();
    const history = useHistory();

  const { DomainType } = useSelector((state) => state.AppReducer);

  const goToSettings = () => {
    if (params) {
      router(
        `/dine-in/auth/settings`,
        `/${params?.domainName}/dine-in/auth/settings`,
        DomainType,
        null,
        `?${queryParam}`
      );
    }
  };

  const goToPaymentComplete = () => {
    router(
      "/dine-in/order/payment-success",
      `/${params?.domainName}/dine-in/order/payment-success`,
      DomainType,
      null,
      `?${queryParam}`
    );
  }

  const goToLogin = () => {
    router(
      "/dine-in/auth/login",
      `/${params?.domainName}/dine-in/auth/login`,
      DomainType,
      null,
      `?${queryParam}`
    );
  };

  const viewBasketPage = () => {
    router(
      `/dine-in/checkout`,
      `/${params.domainName}/dine-in/checkout`,
      DomainType,
      undefined,
      `?${queryParam}`
    );
  };

  const goToPaymentOptions = (paymentOptions) => {
    router(
      "/dine-in/checkout/payment-options",
      `/${params?.domainName}/dine-in/checkout/payment-options`,
      DomainType,
      {
        paymentOptions
      },
      `?${queryParam}`
    );
  };

  const goToOrderAgain = () => {
    router(
      "/dine-in/",
      `/${params?.domainName}/dine-in/`,
      DomainType,
      undefined,
      `?${queryParam}`
    );
  };

  const goToHome = () => {
    router(
      "/dine-in",
      `/${params?.domainName}/dine-in`,
      DomainType,
      null,
      `?${queryParam}`
    );
  };

  const goBack = () => {
    if (window.history.length > 1) {
      history.goBack();
    }else goToHome();
  }

  const gotoVerification = (state) => {
    router(
      `/dine-in/auth/verification`,
      `/${params.domainName}/dine-in/auth/verification`,
      DomainType,
      state,
      `?${queryParam}`
    );
  };

  return {
    goToSettings,
    goToLogin,
    viewBasketPage,
    goToPaymentOptions,
    goToOrderAgain,
    goToHome,
    goBack,
    gotoVerification,
    goToPaymentComplete,
    params,
    router,
    queryParam,
    DomainType
  }
}

export default useDineIn;